var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_601_90",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 0,
    width: 53,
    height: 64
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 37.2441C59 52.021 47.1355 64 32.5 64C17.8645 64 6 52.021 6 37.2441V0H59V37.2441Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_601_90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 12.5C31 19.4036 25.4036 25 18.5 25C11.5964 25 6 19.4036 6 12.5C6 5.59644 11.5964 0 18.5 0C25.4036 0 31 5.59644 31 12.5Z",
    fill: "#4F6DE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 25C35.6415 25 37.267 24.6767 38.7835 24.0485C40.3001 23.4203 41.6781 22.4996 42.8388 21.3388C43.9996 20.1781 44.9203 18.8001 45.5485 17.2835C46.1767 15.767 46.5 14.1415 46.5 12.5C46.5 10.8585 46.1767 9.23303 45.5485 7.71646C44.9203 6.19988 43.9996 4.82189 42.8388 3.66116C41.6781 2.50043 40.3001 1.57969 38.7835 0.951504C37.267 0.32332 35.6415 -7.45058e-07 34 -7.45058e-07L34 12.5V25Z",
    fill: "#708AEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5051 22.0671C53.2516 23.3235 51.7635 24.3201 50.1257 25L50.1257 -7.45058e-07C51.7635 0.679941 53.2516 1.67655 54.5051 2.93291C55.7587 4.18928 56.753 5.6808 57.4314 7.32233C58.1098 8.96385 58.459 10.7232 58.459 12.5C58.459 14.2768 58.1098 16.0361 57.4314 17.6777C56.753 19.3192 55.7587 20.8107 54.5051 22.0671Z",
    fill: "#93ABFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6875 27.3333C5.6875 26.597 6.28445 26 7.02083 26H29.6667C30.403 26 31 26.597 31 27.3333V62.6667C31 63.403 30.403 64 29.6667 64H7.02083C6.28445 64 5.6875 63.403 5.6875 62.6667V27.3333Z",
    fill: "#4F6DE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 26H45.7917C46.528 26 47.125 26.597 47.125 27.3333V64H34V26Z",
    fill: "#708AEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.125 26H57.2292C57.9655 26 58.5625 26.597 58.5625 27.3333V60H50.125V26Z",
    fill: "#93ABFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdm);
export default __webpack_public_path__ + "static/media/Idm.35bb70e27e787434acb503639d96d1c4.svg";
export { ForwardRef as ReactComponent };